
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__pie-chart","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.74 3.06A.93.93 0 008.5 3a1 1 0 00-1 1 1 1 0 00.86 1A3 3 0 115 7.76a1 1 0 00-2 0A1.77 1.77 0 003 8a5 5 0 105.74-4.94zM8 14a6 6 0 116-6 6 6 0 01-6 6zm0-4a2 2 0 10-2-2 2 2 0 002 2z"}})])
          )
        }
      }
    